import { render, staticRenderFns } from "./ReportMenuHistory.vue?vue&type=template&id=0fbaa9aa&"
import script from "./ReportMenuHistory.vue?vue&type=script&lang=js&"
export * from "./ReportMenuHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbaa9aa')) {
      api.createRecord('0fbaa9aa', component.options)
    } else {
      api.reload('0fbaa9aa', component.options)
    }
    module.hot.accept("./ReportMenuHistory.vue?vue&type=template&id=0fbaa9aa&", function () {
      api.rerender('0fbaa9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportMenu/ReportMenuHistory/ReportMenuHistory.vue"
export default component.exports